export default {
    props: {
        markerDefaultsShape: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.shape'
        }, 
        markerDefaultsTooltipAutoHide: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.autoHide'
        }, 
        markerDefaultsTooltipAnimationCloseEffects: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.close.effects'
        }, 
        markerDefaultsTooltipAnimationCloseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.close.duration'
        }, 
        markerDefaultsTooltipAnimationOpenEffects: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.open.effects'
        }, 
        markerDefaultsTooltipAnimationOpenDuration: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.animation.open.duration'
        }, 
        markerDefaultsTooltipContent: {
            type: [String, Function],
            default: undefined,
            kComposite: 'markerDefaults.tooltip.content'
        }, 
        markerDefaultsTooltipContentUrl: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.content.url'
        }, 
        markerDefaultsTooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.template'
        }, 
        markerDefaultsTooltipCallout: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.callout'
        }, 
        markerDefaultsTooltipIframe: {
            type: Boolean,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.iframe'
        }, 
        markerDefaultsTooltipHeight: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.height'
        }, 
        markerDefaultsTooltipWidth: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.width'
        }, 
        markerDefaultsTooltipPosition: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.position'
        }, 
        markerDefaultsTooltipShowAfter: {
            type: Number,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.showAfter'
        }, 
        markerDefaultsTooltipShowOn: {
            type: String,
            default: undefined,
            kComposite: 'markerDefaults.tooltip.showOn'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/MarkerDefaults.js